<script lang="ts">
	import { AutocompleteConfig, type AutocompleteFieldConfig } from '$types/autocompleteFieldConfig'
	import ChipList from '#lib/organisms/ChipList.svelte'
	import { lotTags } from './lotTags.svelte'
	import { t } from '$i18n/i18n'

	let { lotId, readonly = false }: { lotId: string; readonly?: boolean } = $props()

	const tagLabels = $derived(lotTags.tags(lotId).map((tag) => tag.label))
	// Option objects (not labels) feed svelecte directly, so it does not fetch the
	// options endpoint itself — the shared store is the single owner of that request.
	const tagOptions = $derived(lotTags.options(lotId))

	const autocompleteConfig: AutocompleteFieldConfig = $derived({
		...AutocompleteConfig('label', 'label', false, false, true, true, false),
		valueAsObject: false,
		creatable: true,
		creatablePrefix: ''
	})

	// Re-fetch whenever the lot changes. This is an async load into the shared
	// cache (not synchronous derived state), so $effect is the right tool here.
	// Options are only needed by the editable instance (autocomplete + add).
	$effect(() => {
		lotTags.loadTags(lotId)
		if (!readonly) lotTags.loadOptions(lotId)
	})
</script>

<ChipList
	placeholder={$t('UI.tags')}
	list={tagLabels}
	showInput={!readonly}
	readOnly={readonly}
	{autocompleteConfig}
	options={tagOptions}
	singleLineMode
	onAddChip={(label) => lotTags.add(lotId, label)}
	onChipRemoved={(label) => lotTags.remove(lotId, label)}
/>
